import { createFileRoute } from '@tanstack/react-router'

import { DelegationsPage } from '@/features/user-management/DelegationsPage'

export const Route = createFileRoute('/_authenticated/leave-mgt/delegations')({
  component: DelegationsPage,
})
